<template>
  <ul class="menu-nav">
    <li class="menu-section" >
      <h4 class="menu-text">Master</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      tag="li"
      to="/masters/users"
      active-class="menu-item-active"
      exact-active-class="menu-item-active"
      class="menu-item"
      aria-haspopup="true"
      data-menu-toggle="hover"
      v-if="user"
    >
      <a class="menu-link">
        <i class="menu-icon fas fa-users"></i>
        <span class="menu-text">User</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      to="/masters/roles"
      active-class="menu-item-active"
      exact-active-class="menu-item-active"
      class="menu-item"
      aria-haspopup="true"
      data-menu-toggle="hover"
      v-if="role"
    >
      <a class="menu-link">
        <i class="menu-icon fas fa-user-circle"></i>
        <span class="menu-text">Peran</span>
      </a>
    </router-link>

    <li class="menu-section" v-if="settingTitle">
      <h4 class="menu-text">Setting</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <router-link
      tag="li"
      to="/masters/user-managements/role-access"
      active-class="menu-item-active"
      exact-active-class="menu-item-active"
      class="menu-item"
      aria-haspopup="true"
      data-menu-toggle="hover"
      v-if="roleAccess"
    >
      <a class="menu-link">
        <i class="menu-icon fas fa-user-cog"></i>
        <span class="menu-text">Hak Akses Peran</span>
      </a>
    </router-link>

    <router-link
      tag="li"
      to="/masters/user-managements/user-access"
      active-class="menu-item-active"
      exact-active-class="menu-item-active"
      class="menu-item"
      aria-haspopup="true"
      data-menu-toggle="hover"
      v-if="userAccess"
    >
      <a class="menu-link">
        <i class="menu-icon fas fa-users-cog"></i>
        <span class="menu-text">Hak Akses User</span>
      </a>
    </router-link>

    <li class="menu-section">
      <h4 class="menu-text">Tampilan</h4>
      <i class="menu-icon flaticon-more-v2"></i>
    </li>

    <li
      aria-haspopup="true"
      class="menu-item"
      @click="toggleDarkMode"
      style="cursor: pointer;"
    >
      <div class="menu-link d-flex align-items-center justify-content-between">
        <span class="d-flex align-items-center">
          <i
            class="menu-icon fas"
            :class="isDarkMode ? 'fa-sun text-warning-custom' : 'fa-moon text-dark-custom'"
            style="font-size: 14px;"
          ></i>
          <span class="menu-text" style="margin-left: 12px;">Mode Gelap</span>
        </span>
        <span class="switch-control" :class="{ 'active': isDarkMode }">
          <span class="switch-knob"></span>
        </span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Master",
  data(){
    return{
      // access
      masterTitle: true,
      role: true,
      user: true,
      settingTitle: true,
      settingView: true,
      roleAccess: true,
      userAccess: true,
      isDarkMode: false
    }
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    checkAccess() {
      
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      const theme = this.isDarkMode ? "dark" : "light";
      localStorage.setItem("theme", theme);
      document.documentElement.setAttribute("data-theme", theme);
      this.$root.$emit("theme-changed", theme);
    }
  },
  mounted(){
    this.checkAccess()
    this.$root.$on("refreshMasterAside", () => {
      this.checkAccess();
    });

    const savedTheme = localStorage.getItem("theme") || "light";
    this.isDarkMode = savedTheme === "dark";

    this.$root.$on("theme-changed", (theme) => {
      this.isDarkMode = theme === "dark";
    });
  }
};
</script>

<style scoped>
.text-warning-custom {
  color: #f59e0b !important;
}
.text-dark-custom {
  color: #64748b !important;
}

.switch-control {
  width: 34px;
  height: 18px;
  border-radius: 18px;
  background-color: #cbd5e1;
  position: relative;
  transition: background-color 0.2s ease;
  display: inline-block;
  flex-shrink: 0;
}
.switch-control.active {
  background-color: #1e958f;
}
.switch-knob {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #ffffff;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}
.switch-control.active .switch-knob {
  transform: translateX(16px);
}
</style>
